export default __webpack_public_path__ + "static/media/imageTile.9753023a.gif";